



















































































import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { Component, Prop, Vue } from "vue-property-decorator";

export type IHasDue = {
  /**
   * The due date to check
   */
  due: string;

  /**
   * The check to set due if not matching the due of the component
   */
  state: string;
};

@Component({
  components: {},
  filters: {
    simpleDoubleDigitDate
  }
})
export default class DueDateChip extends Vue {
  /**
   * Items that have a property `due` and `state`
   * @see IHasDue
   * @example
   *  ```
   *  :ticket="{ due: item.due, state: item.status }"
   *  ```
   */
  @Prop()
  ticket!: IHasDue;

  /**
   * The states which indicate "due" to test against.
   * Include all "not done" states.
   */
  @Prop({ default: () => ["open"] })
  states!: string[];

  /**
   * filter tickets for a match with any of the given references
   */
  @Prop({ default: true })
  chip!: boolean;

  due(due: string) {
    if (!due) {
      return "";
    }

    return new Date(due);
  }

  get isChip() {
    if (this.chip) {
      return "v-chip";
    }
    return "span";
  }
  /**
   * end of today
   */
  get eod() {
    const date = new Date();
    date.setUTCHours(23, 59, 59, 59);

    return date;
  }

  /**
   * beginning of today
   */
  get bod() {
    const date = new Date();
    date.setUTCHours(0, 0, 0, 0);

    return date;
  }

  /**
   * beginning of yesterday
   */
  get yesterday() {
    const date = new Date();
    date.setUTCHours(0, 0, 0, 0);
    return date.setDate(date.getDate() - 1);
  }

  /**
   * end of tomorrow
   */
  get totomorrow() {
    const date = new Date();
    date.setUTCHours(23, 59, 59, 59);
    return date.setDate(date.getDate() + 1);
  }

  isOverdue(ticket: IHasDue) {
    if (ticket.due && this.states.includes(ticket.state)) {
      return new Date(ticket.due) < new Date();
    }

    return false;
  }
}
